import { html, ifDefined } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';
import { infrastructure, moduleLoader } from '../infrastructure.js';

/**
 * @param {UrlSearchParams} query - object representing query parameters
 * @returns {TemplateResult}
 */
export default function renderPaymentPageTemplate({ query, anchor }) {
  moduleLoader.loadModule(config.lucyWidgetUrl);
  const suma = query.get('suma');
  const code = query.get('code');
  const provider = query.get('provider');

  return html`
    <osk-payment-page
      .infrastructure=${infrastructure}
      .query=${query}
      anchor=${ifDefined(anchor)}
      code=${ifDefined(code)}
      after-payment-return-url=${`${window.location.origin}${config.linkConfiguration.invoicePayLink}`}
      amount=${ifDefined(suma)}
      provider=${ifDefined(provider)}
      class="vertical-stretch"
    ></osk-payment-page>
  `;
}
